export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_rc-pagination@1.17.10@rc-pagination/es/index.js
// module id = 722
// module chunks = 0